// @flow

import 'classlist-polyfill';
import 'core-js/modules/es.set';
import 'core-js/modules/es.map';
import 'core-js/modules/es.array.iterator';
import 'core-js/modules/es.array.find';
import 'core-js/modules/es.array.find-index';
import 'raf/polyfill';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { matchPath } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import 'font-awesome/css/font-awesome.min.css';
import Mobile from 'app/containers/Mobile';
import isMobile from 'app/utils/isMobile';
import Router from './routes/index';
import './i18n';
import './styles';

window.appVersion = _.get(process.env.APP_CONFIG, ['APP_GLOBAL_CONFIG', 'APP_VERSION'], '');

if ((process.env.NODE_ENV === 'production') && (process.env.SKIP_SENTRY !== 'false') && (_.get(process.env.APP_CONFIG, ['APP_DETAILS', 'EN_NAME'], '') === 'Filimo')) {
  const history = createBrowserHistory();
  const routes = [
    { path: '/:lang/signin' },
    { path: '/:lang/search' },
    { path: '/:lang/bookmarks' },
    { path: '/:lang/payment' },
    { path: '/:lang/profile' },
    { path: '/:lang/grid/:id' },
    { path: '/:lang/details/:id' },
    { path: '/:lang/m/:id' },
    { path: '/:lang/w/:id' },
    { path: '/:lang/l/:id' },
    { path: '/:lang/c/:id' },
    { path: '/:lang/:tag_id?' },
    { path: '/:lang/' },
  ];
  Sentry.init({
    dsn: 'https://63917aa7bd064b53ace702190cb8c4fd@o76567.ingest.sentry.io/1321859',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history, routes, matchPath),
      }),
    ],
    tracesSampleRate: 1.0,
    release: _.get(process.env.APP_CONFIG, ['APP_GLOBAL_CONFIG', 'APP_VERSION'], ''),
    environment: process.env.NODE_ENV,
  });
  Sentry.configureScope((scope : any) => {
    const authenticationData = _.get(JSON.parse(localStorage.getItem('reduxState') || '{}'), ['Login', 'authenticationData']);
    if (authenticationData) {
      scope.setUser({
        username: _.get(authenticationData, 'username', ''),
      });
    }
    scope.setTag('LG_APP', _.get(window, ['webOS', 'platform', 'tv']) ? 'YES' : 'NO');
  });
}

ReactDOM.render(isMobile.any() ? <Mobile /> : <Router />, (document.getElementById('app') : any));
